import { Users, Star, TrendingUp, Flame, FileText, XCircle, Trophy, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export const STAT_ICONS: Record<string, { icon: typeof Users; color: string; bg: string }> = {
  "Total users": { icon: Users, color: "text-info", bg: "bg-info/10" },
  "Premium users": { icon: Star, color: "text-warning", bg: "bg-warning/10" },
  "Monthly revenue": { icon: TrendingUp, color: "text-success", bg: "bg-success/10" },
  "Premium rate": { icon: Flame, color: "text-primary", bg: "bg-secondary" },
  Resources: { icon: FileText, color: "text-primary", bg: "bg-secondary" },
  "AI generations": { icon: TrendingUp, color: "text-primary", bg: "bg-primary/10" },
};

export const ACTIVITY_ICONS: Record<string, { icon: typeof Star; color: string; bg: string }> = {
  upgrade: { icon: Star, color: "text-warning", bg: "bg-warning/10" },
  register: { icon: Users, color: "text-info", bg: "bg-info/10" },
  quiz: { icon: Trophy, color: "text-success", bg: "bg-success/10" },
  error: { icon: XCircle, color: "text-destructive", bg: "bg-destructive/10" },
  download: { icon: FileText, color: "text-primary", bg: "bg-secondary" },
};

export function useAdminToken() {
  const { tokens } = useAuth();
  return tokens?.accessToken ?? null;
}

export function PageLoader() {
  return (
    <div className="flex items-center justify-center p-20 text-muted-foreground">
      <Loader2 size={24} className="animate-spin mr-2" /> Loading…
    </div>
  );
}

export function PageError({ message }: { message: string }) {
  return (
    <div className="p-8">
      <p className="text-sm text-destructive bg-destructive/10 border border-destructive/30 rounded-md px-4 py-3">{message}</p>
    </div>
  );
}

export function todayLabel() {
  return new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "short", year: "numeric" });
}
